export const PATH_NAME = {
  ROOT: '/',
  LOGIN: '/dang-nhap',
  INTRO: '/thu-thach',
  SELECT_METHOD: '/chon-phuong-thuc',
  TRUYEN_THONG: '/truyen-thong',
  CHAY_TRAM: '/chay-tram',
  RESULT: '/ket-qua',
  NOT_FOUND: '/404',
  CHON_TRUYEN_THONG: '/bat-dau-voi-trai-nghiem-truyen-thong',
  CHON_CHAY_TRAM: '/bat-dau-voi-trai-nghiem-chay-tram',
};
